export const INVITES_ROLE_LABEL_MAPPING = {
  'instance-admin': 'Admin',
  'instance-member': 'Member',
  'parent-instance-admin': 'Admin',
};
